import {
  PopoverTrigger,
  Popover,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Portal,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';

interface Props {
  children: React.ReactNode;
  isOpen?: boolean;
  content?: React.ReactNode;
  placement?: 'bottom-start' | 'left-start' | 'right-start';
  fallbackPlacements?: Array<'bottom-start' | 'left-start' | 'right-start'>;
}

const delay = 300;

export function HoverCard({
  children,
  content,
  isOpen,
  placement = 'bottom-start',
  fallbackPlacements,
}: Props) {
  const [open, setOpen] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (isOpen === undefined) return;

    if (isOpen === false) {
      setOpen(false);
      return;
    }

    const timeout = setTimeout(() => {
      setOpen(true);
    }, delay);

    return () => clearTimeout(timeout);
  }, [isOpen]);

  if (!content) {
    return <>{children}</>;
  }

  return (
    <Popover
      trigger="hover"
      placement={placement}
      isOpen={open}
      openDelay={delay}
      modifiers={
        fallbackPlacements
          ? [
              {
                name: 'flip',
                options: { fallbackPlacements },
              },
            ]
          : undefined
      }
    >
      <PopoverTrigger>{children}</PopoverTrigger>
      <Portal>
        <PopoverContent width="auto" minW="unset" maxW="calc(100vw - 2rem)">
          <PopoverArrow />
          <PopoverBody maxW="inherit">{content}</PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
